import axios from 'axios';
// import jwt_decode from 'jwt-decode';
// import router from '../../router';
// import { auth } from '../../store/auth.module';


const baseURL = process.env.VUE_APP_PAYMENT_API_URL;
const timeout = process.env.VUE_APP_TIME_OUT;
const paymentApi = axios.create({
    baseURL,
    timeout,
});


// paymentApi.interceptors.request.use(
//     async (config) => {
//         if (auth.state.user) {
//             let accessToken = auth.state.user.accessToken;
//             const refreshToken = auth.state.user.refreshToken;

//             if (accessToken && refreshToken) {
//                 const jwtObject = jwt_decode(accessToken);

//                 // 토큰만료 시간이 지난 경우 갱신 처리
//                 if (new Date().getTime() >= jwtObject.exp) {
//                     await axios
//                         .put(`${baseURL}/admin/paymentApi/auth`, {
//                             accessToken,
//                             refreshToken,
//                         })
//                         .then((response) => {
//                             if (response.data.accessToken) {
//                                 const jwtObject = jwt_decode(
//                                     response.data.accessToken
//                                 );

//                                 const retParams = { ...jwtObject };

//                                 console.log(
//                                     '=========== FIND data.centerChains ===================='
//                                 );
//                                 console.log(response.data, retParams);
//                                 console.log('===============================');

//                                 retParams.accessToken =
//                                     response.data.accessToken;
//                                 retParams.refreshToken =
//                                     response.data.refreshToken;
//                                 retParams.centerId = retParams.cid;
//                                 retParams.userId = retParams.lid;
//                                 retParams.userName = retParams.unm;
//                                 retParams.roleId = retParams.rid;
//                                 retParams.roleName = retParams.rnm;
//                                 retParams.centerChains =
//                                     response.data.centerChains;

//                                 localStorage.setItem(
//                                     'userInfo',
//                                     JSON.stringify(retParams)
//                                 );

//                                 auth.state.user = response.data;
//                                 accessToken = response.data.accessToken;
//                                 console.log('===> 토큰 갱신 성공 ');
//                             }
//                         });
//                 }
//                 config.headers.common.Authorization = `Bearer ${accessToken}`;
//             } else {
//                 // 세션 만기시, 전체 세션관련 캐시 버리기
//                 if (auth.state.user) {
//                     paymentApi.delete(
//                         `/admin/paymentApi/auth/${auth.state.user.refreshToken}`
//                     );
//                     localStorage.removeItem('userInfo');
//                     localStorage.removeItem('userMenu');
//                     localStorage.removeItem('menuEventCds');
//                 }
//                 router.push('/login');
//             }
//         }
//         return config;
//     },
//     (error) => {
//         // 요청 에러 처리
//         console.log(`===> paymentApi interceptors request error : ${error}`);
//         return Promise.reject(error);
//     }
// );

// paymentApi.interceptors.response.use(
//     async (response) => {
//         if (
//             response.status === 200 &&
//             response.config.url === '/admin/paymentApi/auth'
//         ) {
//             if (response.data.accessToken) {
//                 const jwtObject = jwt_decode(response.data.accessToken);
//                 await axios
//                     .get(
//                         `${baseURL}/admin/paymentApi/centerStaffRole/centerMenu/${jwtObject.cid}/${jwtObject.rid}`,
//                         {
//                             headers: {
//                                 Authorization: `Bearer ${response.data.accessToken}`,
//                             },
//                         }
//                     )
//                     .then((res) => {
//                         localStorage.setItem(
//                             'userMenu',
//                             JSON.stringify(res.data)
//                         );

//                         console.log('userMenu', res.data);

//                         console.log('===> 센터 직원별 메뉴 가져오기 성공');
//                     });
//             }
//         }
//         return response;
//     },

//     async (error) => {
//         // 응답 에러 처리를 작성
//         console.log(`===> paymentApi interceptors response error : ${error}`);
//         if (error.response && error.response.status === 401) {
//             router.push('/login');
//         }

//         return Promise.reject(error);
//     }
//);
export default paymentApi;
